import {theme} from '@/services/getSiteTheme';
import {clearProgramCart, isCartFlowRoute} from '@/helpers/startProgramCheckout';
import {createRouter, createWebHistory} from 'vue-router';

import {isInFrame} from '@academy/utils';

import {routes} from './routes';

const router = createRouter({
    history: createWebHistory(import.meta.env.BASE_URL),
    routes,
    scrollBehavior(to) {
        if (to.hash && to.name !== '/products/abstractProductCode') {
            return {
                el: to.hash,
                behavior: 'smooth',
            };
        }
        if (to.name === '/products/abstractProductCode') {
            return null;
        }

        return {top: 0};
    },
});

const PAGE_TITLE_SUFFIX = ' | AfterSchoolVote';

router.beforeEach((to, from, next) => {
    const loggedIn = localStorage.getItem('user');
    const title = to.query.title ? to.query.title : to.meta.title;
    document.title = title + PAGE_TITLE_SUFFIX;
    if (isInFrame()) {
        if (to.meta.availableInIframe) {
            next();
        } else {
            next({name: '/programs'});
        }

        return;
    }
    if (to.matched.some((record) => record.meta.requiresAuth) && !loggedIn) {
        next({name: '/login'});
    } else {
        next();
    }
});

router.afterEach((to, from) => {
    if (isCartFlowRoute(from.name) && !isCartFlowRoute(to.name)) {
        clearProgramCart();
    }
});

export default router;
